import type { IOptions } from "sanitize-html";
import sanitizeHTML from "sanitize-html";
import type React from "react";

export const SanitizedHTML: React.FC<{
  id?: string;
  html: string;
  options: IOptions;
}> = (props) => {
  const sanitizedHTML = sanitizeHTML(props.html, { ...props.options });

  return (
    <div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} id={props.id} />
  );
};
